/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import MKButton from "components/MKButton";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Guarantee() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="light"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h2">OUR GUARANTEE</MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <MKTypography display="block" variant="h2" color="info" textGradient>
              {" "}
              <Icon>gpp_good</Icon>{" "}
            </MKTypography>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={4}>
                <MKBox mb={1}>
                  <MKTypography variant="h4">QUALITY WORKMANSHIP</MKTypography>
                </MKBox>
              </Grid>

              <Grid item xs={12} lg={6}>
                <MKBox mb={1} pr={2}>
                  <MKTypography variant="body2" color="text">
                    With decades of hands-on experience passed down through two generations, we take
                    pride in delivering reliable, honest, and detail-focused work. Whether it’s a
                    simple repair or a full renovation, we make sure the job is done right — the
                    first time, every time.
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} lg={2}>
                <MKButton component="a" href="#contact" color="dark" size="small" fullWidth>
                  Contact Us
                </MKButton>
              </Grid>
            </Grid>
            <Divider style={{ background: "black" }} sx={{ mt: "4", mb: 0 }} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <MKTypography display="block" variant="h2" color="info" textGradient>
              {" "}
              <Icon>gpp_good</Icon>{" "}
            </MKTypography>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={4}>
                <MKBox mb={1}>
                  <MKTypography variant="h4">CUSTOMER SATISFACTION</MKTypography>
                </MKBox>
              </Grid>

              <Grid item xs={12} lg={6}>
                <MKBox mb={1} pr={2}>
                  <MKTypography variant="body2" color="text">
                    Customer satisfaction is our top priority. We strive to exceed customer
                    expectations by providing exceptional service, reliable solutions, and a
                    positive experience with every interaction.
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} lg={2}>
                <MKButton component="a" href="#review" color="dark" size="small" fullWidth>
                  Our Reviews
                </MKButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Guarantee;
